import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

export const minExperienceCriteria = 1;
export const maxExperienceCriteria = 5;

export interface RhfCriteriaValue {
    criteriaId: string;
    value: string;
}

const criteriaItemSchema = z.object({
    criteriaId: z.string(),
    value: z.string().min(1, ValidationErrors.Required).max(1024, UIStrings.MaxSymbolsValidationError(1024)),
});

export const identifyExperienceSchema = z.object({
    criteria: z
        .array(criteriaItemSchema)
        .min(minExperienceCriteria, ValidationErrors.PleaseAddAtLeastOneCriteriaRequiredError)
        .max(maxExperienceCriteria),
});

export type IdentifyExperienceFormValues = z.infer<typeof identifyExperienceSchema>;

export const defaultIdentifyExperienceFormValues: IdentifyExperienceFormValues = {
    criteria: [],
};

export const experienceCriteriaFieldNames: { [key in keyof IdentifyExperienceFormValues]: key } = {
    criteria: 'criteria',
};
